export type ExternalGameLaunchMode = "frame" | "navigate";

export interface ExternalLaunchableGame {
  readonly slug: string;
  readonly url: `https://${string}`;
}

export interface ExternalGameLaunchHooks {
  navigate(url: `https://${string}`): void;
  pushTransientHistory(slug: string): void;
  frame(): void;
}

export type ExternalGameLaunchResult = "frame" | "navigate";

/**
 * External games have two honest launch modes:
 * - frame: CARCADE is permitted to keep the game inside ExternalOverlay.
 * - navigate: the source must own the top-level page (for example because
 *   frame-ancestors/X-Frame-Options explicitly reject CARCADE).
 */
export function launchExternalGame(
  link: ExternalLaunchableGame,
  mode: ExternalGameLaunchMode,
  hooks: ExternalGameLaunchHooks,
): ExternalGameLaunchResult {
  if (mode === "navigate") {
    hooks.navigate(link.url);
    return "navigate";
  }

  hooks.pushTransientHistory(link.slug);
  hooks.frame();
  return "frame";
}
